<template>
  <div v-if="isdisplay" class="pas-overlay" @click.self="close">
    <div class="pas-dialog">

      <!-- Header -->
      <div class="pas-head">
        <div class="pas-head-left">
          <div class="pas-head-icon"><i class="ri-user-add-line"></i></div>
          <div class="pas-head-txt">
            <span>Autoriser un serveur</span>
            <small>Prise de service sur le téléphone du personnel</small>
          </div>
        </div>
        <button class="pas-close" @click="close" aria-label="Fermer">
          <i class="ri-close-line"></i>
        </button>
      </div>

      <div class="pas-body">

        <!-- Scan & Go non configuré : sans clé, l'URL serait syntaxiquement
             valide mais systématiquement refusée. Mieux vaut ne rien produire
             que d'envoyer le serveur se faire rejeter sans comprendre. -->
        <div v-if="!cleDisponible" class="pas-err">
          <i class="ri-error-warning-line"></i>
          <span>
            Scan &amp; Go n'est pas configuré pour cette société.
            Aucun QR ne peut être délivré - voyez avec votre administrateur.
          </span>
        </div>

        <!-- ÉTAPE 1 - choix du serveur.
             La liste et le QR ne coexistent pas : afficher les deux obligeait à
             faire défiler pour revenir choisir le suivant. Or le cas nominal
             est une file de serveurs qui défilent devant la caisse. -->
        <template v-else-if="!choisi">
          <label class="pas-lbl">Serveur qui prend son service</label>
          <div class="pas-search">
            <i class="ri-search-line"></i>
            <input ref="champRecherche" v-model="recherche" type="search"
                   placeholder="Rechercher un serveur…" />
          </div>

          <div class="pas-liste">
            <button v-for="c in visibles" :key="c.pid" class="pas-item"
                    @click="selectionner(c)">
              <span class="pas-item-ini">{{ initiales(c.name) }}</span>
              <span class="pas-item-nom">{{ c.name }}</span>
              <!-- « QR délivré » et non « en service » : la caisse ne sait pas
                   si le serveur a effectivement scanné ni s'il a clôturé. -->
              <span v-if="dejaDelivre(c.pid)" class="pas-item-fait">
                <i class="ri-check-line"></i> QR délivré
              </span>
            </button>

            <div v-if="!visibles.length" class="pas-vide">
              <i class="ri-user-search-line"></i>
              <p>{{ collaborateurs.length ? 'Aucun résultat' : 'Aucun serveur enregistré' }}</p>
              <small v-if="!collaborateurs.length">
                Ajoutez vos serveurs comme collaborateurs dans Définition.
              </small>
            </div>
          </div>
        </template>

        <!-- ÉTAPE 2 - le QR, seul à l'écran. -->
        <template v-else>
          <button class="pas-retour" @click="retourListe">
            <i class="ri-arrow-left-line"></i> Choisir un autre serveur
          </button>

          <div class="pas-qr-zone">
            <div v-if="chargement" class="pas-qr-load">
              <i class="ri-loader-4-line pas-spin"></i>
              <p>Génération…</p>
            </div>

            <template v-else-if="qr">
              <p class="pas-pour">
                Prise de service pour <strong>{{ choisi.name }}</strong>
              </p>

              <div class="pas-qr-wrap">
                <img :src="qr" :alt="'QR de prise de service pour ' + choisi.name" class="pas-qr" />
              </div>

              <p class="pas-consigne">
                <strong>1.</strong> Ouvrez l'appareil photo du téléphone &nbsp;
                <strong>2.</strong> Visez ce QR &nbsp;
                <strong>3.</strong> Ouvrez le lien proposé
              </p>

              <details class="pas-lien">
                <summary>Afficher le lien</summary>
                <div class="pas-lien-row">
                  <code>{{ lien }}</code>
                  <button @click="copierLien" title="Copier"><i class="ri-file-copy-line"></i></button>
                </div>
              </details>
            </template>

            <div v-else-if="erreur" class="pas-err">
              <i class="ri-error-warning-line"></i>
              <span>{{ erreur }}</span>
            </div>
          </div>
        </template>

      </div>

      <div class="pas-foot">
        <span v-if="!choisi" class="pas-foot-info">
          <i class="ri-information-line"></i>
          Le QR reste valable tant que le serveur n'a pas clôturé son service.
        </span>
        <span v-else class="pas-foot-info">
          <i class="ri-information-line"></i>
          {{ compteDelivres }} QR délivré{{ compteDelivres > 1 ? 's' : '' }} depuis l'ouverture.
        </span>

        <!-- Sortie principale quand un QR est affiché : enchaîner. Le caissier
             a une file devant lui, « Fermer » n'est pas ce qu'il cherche. -->
        <button v-if="choisi" class="pas-btn-pri" @click="retourListe">
          <i class="ri-user-add-line"></i> Serveur suivant
        </button>
        <button v-else class="pas-btn-pri" @click="close">Fermer</button>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
const axios = require("axios");
import qrcodetoimage from "qrcode";
import * as JwtService from "@/common/jwt.service";
import { randomString } from "@/allfunction";

export default {
    name: "modalautoriserserveur",

    data: () => ({
        isdisplay: false,
        collaborateurs: [],
        soc: "", mag: "", cle: "", pidcaisse: "",
        recherche: "",
        choisi: null,
        qr: "", lien: "",
        chargement: false,
        erreur: "",

        /* Serveurs auxquels un QR a été délivré depuis l'ouverture de la caisse.
           Repère de file uniquement : avec cinquante serveurs qui défilent, le
           caissier perd le fil de qui est déjà passé. Volontairement PAS remis à
           zéro par show() - refermer la modale par erreur en pleine file ne doit
           pas effacer ce repère. Il disparaît à la fermeture de la caisse. */
        delivres: [],
    }),

    computed: {
        cleDisponible() { return String(this.cle || "").trim() !== ""; },

        compteDelivres() { return this.delivres.length; },

        visibles() {
            const q = this.recherche.trim().toLowerCase();
            if (!q) return this.collaborateurs;
            return this.collaborateurs.filter(
                (c) => String(c.name || "").toLowerCase().indexOf(q) !== -1
            );
        },
    },

    methods: {
        /**
         * @param {Array}  collaborateurs  otherdatatable.collaborateur ({pid, name})
         * @param {String} soc             société courante
         * @param {String} mag             magasin de la caisse
         * @param {String} cle             licence authscango
         */
        show(collaborateurs, soc, mag, cle, pidcaisse) {
            this.collaborateurs = Array.isArray(collaborateurs) ? collaborateurs : [];
            this.soc = String(soc || "");
            this.mag = String(mag || "");
            this.cle = String(cle || "");
            this.pidcaisse = String(pidcaisse || "");
            this.recherche = "";
            this.choisi = null;
            this.qr = ""; this.lien = ""; this.erreur = "";
            this.isdisplay = true;
        },

        _headers() {
            return {
                'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + JwtService.getToken(),
                'csrftoken': this.$store.state.appsociete
            };
        },

        /**
         * Demande au backend un jeton d'enrôlement 24h pour le serveur choisi.
         *
         * C'est AUSSI le point où le backend contrôle le quota de serveurs de la
         * licence (nbredevice) et réserve le slot de prise de service. On distingue
         * donc deux natures d'échec :
         *  - `SERVEUR_QUOTA_EXCEEDED` → refus MÉTIER BLOQUANT : le quota est atteint,
         *    on ne délivre PAS de QR (sinon le serveur prendrait service en mode QR
         *    seul et contournerait le plafond).
         *  - tout autre échec (réseau, Scan & Go non configuré) → le temps réel est
         *    un BONUS : on délivre le QR sans room/token, mode QR seul.
         *
         * @returns {Promise<{ok:boolean, room?:string, token?:string, code?:string}>}
         */
        async minterEnrolement() {
            if (!this.pidcaisse || !this.choisi) return { ok: true };
            try {
                const url = process.env.VUE_APP_API_URL
                    + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/enrolement/'
                    + randomString();
                const res = await axios.post(url, {
                    pidcaisse: this.pidcaisse,
                    serveurPid: this.choisi.pid,
                    serveurNom: this.choisi.name,
                }, { headers: this._headers(), withCredentials: true });

                const d = res.data || {};
                if (d.success && d.m && d.m.token) {
                    return { ok: true, room: d.m.room, token: d.m.token };
                }
                // Refus explicite du backend : le quota est le seul qui bloque.
                const code = d.m && d.m.code ? String(d.m.code) : "";
                if (code === "SERVEUR_QUOTA_EXCEEDED") {
                    return { ok: false, code };
                }
                // Autre refus (KEY_INVALID = module non configuré, etc.) → repli QR.
            } catch (e) {
                console.warn("[serveur] enrôlement temps réel indisponible:", e);
            }
            return { ok: true };   // repli gracieux en mode QR seul
        },

        /**
         * Demande un lien court pour l'URL d'enrôlement (route protégée, caisse
         * authentifiée). Renvoie l'URL courte, ou "" en cas d'échec (repli sur
         * l'URL longue par l'appelant). La cible transmise est le CHEMIN relatif
         * (sans l'origine) - ce que le backend valide et ce vers quoi /s/:code
         * redirige.
         * @param {string} longUrl URL absolue construite par construireLien
         * @returns {Promise<string>}
         */
        async demanderLienCourtServeur(longUrl) {
            if (!this.choisi) return "";
            try {
                const base = String(process.env.VUE_APP_URL || "").replace(/\/+$/, "");
                let cible = String(longUrl || "");
                if (base && cible.indexOf(base) === 0) cible = cible.slice(base.length);
                if (cible[0] !== "/") return "";   // cible relative attendue

                const url = process.env.VUE_APP_API_URL
                    + '/egl745874pscango771714dfe/caisse/othetdskd8755dsdhisd/shortlink/'
                    + randomString();
                const res = await axios.post(url, {
                    type: "serveur",
                    cible: cible,
                    scope: this.choisi.pid,
                }, { headers: this._headers(), withCredentials: true });

                const d = res.data || {};
                if (d.success && d.m && d.m.code) {
                    return base + "/s/" + d.m.code;
                }
            } catch (e) {
                console.warn("[serveur] lien court indisponible, repli URL longue:", e);
            }
            return "";
        },

        close() {
            this.isdisplay = false;
            // On ne conserve pas le QR d'un serveur d'une ouverture à l'autre :
            // le caissier repart d'une liste vierge. `delivres`, lui, survit.
            this.choisi = null;
            this.qr = ""; this.lien = "";
        },

        /**
         * Referme le QR et rend la main à la liste, modale ouverte.
         *
         * C'est l'action la plus fréquente : les serveurs se présentent à la
         * suite, et le caissier enchaîne. Le champ de recherche reprend le
         * focus et se vide, prêt pour le nom suivant.
         */
        retourListe() {
            this.choisi = null;
            this.qr = ""; this.lien = ""; this.erreur = "";
            this.recherche = "";
            this.$nextTick(() => {
                if (this.$refs.champRecherche) this.$refs.champRecherche.focus();
            });
        },

        dejaDelivre(pid) { return this.delivres.indexOf(pid) !== -1; },

        initiales(nom) {
            return String(nom || "")
                .split(/\s+/).filter(Boolean).slice(0, 2)
                .map((m) => m[0]).join("").toUpperCase();
        },

        async selectionner(c) {
            this.choisi = c;
            await this.genererQr();
        },

        /**
         * Le lien porte tout ce dont le téléphone a besoin : société, magasin,
         * licence, et le collaborateur désigné. Le téléphone du serveur est
         * vierge - il scanne avec son appareil photo natif, qui ouvre une URL.
         * Rien ne peut donc transiter autrement que par cette URL.
         */
        construireLien(enrol) {
            const base = String(process.env.VUE_APP_URL || "").replace(/\/+$/, "");

            let url = base + "/serveur/"
                + encodeURIComponent(this.mag) + "/"
                + encodeURIComponent(this.cle)
                + "?c=" + encodeURIComponent(this.choisi.pid)
                + "&n=" + encodeURIComponent(this.choisi.name);

            /* Temps réel : room + jeton + caisse embarqués → le serveur rejoint le
               canal WebSocket dès la prise de service. Absents (mint échoué) : le
               serveur reste en mode QR, dégradation gracieuse. */
            if (enrol && enrol.room && enrol.token) {
                url += "&r=" + encodeURIComponent(enrol.room)
                     + "&tk=" + encodeURIComponent(enrol.token)
                     + "&pc=" + encodeURIComponent(this.pidcaisse);
            }
            return url;
        },

        async genererQr() {
            this.chargement = true;
            this.erreur = "";
            this.qr = "";
            try {
                const enrol = await this.minterEnrolement();
                // Quota de serveurs atteint : refus BLOQUANT, aucun QR délivré.
                if (enrol && enrol.ok === false && enrol.code === "SERVEUR_QUOTA_EXCEEDED") {
                    this.erreur = "Quota de serveurs de la licence atteint. Clôturez le service d'un serveur ou augmentez la licence.";
                    this.chargement = false;
                    return;
                }
                const enrolRt = enrol && enrol.ok ? enrol : null;
                this.lien = this.construireLien(enrolRt);

                /* Raccourcisseur : on remplace l'URL longue (~520 car., 73×73
                   modules) par un lien court résolu à la volée → QR nettement moins
                   dense, scan bien plus rapide. Best-effort : si le backend ne rend
                   pas de code, on garde l'URL longue (QR dense mais fonctionnel).
                   Le lien serveur expire au prochain 9h (côté backend). */
                const court = await this.demanderLienCourtServeur(this.lien);
                if (court) this.lien = court;
                /* 400 px et non 320 comme l'appairage : l'URL atteint ~520
                   caractères (la licence en fait 280, le pid du collaborateur
                   jusqu'à 94). À 320 px la trame descend sous 3,5 px par
                   module - illisible pour un téléphone d'entrée de gamme dans
                   une salle peu éclairée. Niveau M conservé : il tolère les
                   reflets d'écran, qui sont le vrai ennemi ici. */
                this.qr = await qrcodetoimage.toDataURL(this.lien, {
                    errorCorrectionLevel: "M",
                    margin: 2,
                    width: 400,
                });
                if (this.delivres.indexOf(this.choisi.pid) === -1) {
                    this.delivres.push(this.choisi.pid);
                }
            } catch (e) {
                console.warn("[serveur] génération QR:", e);
                this.erreur = "Impossible de générer le code. Réessayez.";
            } finally {
                this.chargement = false;
            }
        },

        copierLien() {
            try {
                navigator.clipboard.writeText(this.lien);
                if (window.toastr) window.toastr.success("Lien copié.", "<b></b>");
            } catch (e) { /* presse-papier indisponible : le lien reste lisible */ }
        },
    },
};
</script>

<style scoped>
.pas-overlay {
  position: fixed; inset: 0; z-index: 10030;
  background: rgba(0, 0, 0, .55);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  font-family: 'Segoe UI', system-ui, sans-serif;
}

.pas-dialog {
  background: var(--surface); border: 1px solid var(--border);
  border-radius: 14px; width: min(460px, 100%); max-height: 92vh;
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .45);
  animation: pas-in .2s cubic-bezier(.4, 0, .2, 1);
}
@keyframes pas-in {
  from { opacity: 0; transform: scale(.93) translateY(10px); }
  to   { opacity: 1; transform: none; }
}

.pas-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid var(--border); flex-shrink: 0;
}
.pas-head-left { display: flex; align-items: center; gap: 10px; }
.pas-head-icon {
  width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
  background: color-mix(in srgb, var(--accent) 15%, transparent);
  color: var(--accent); font-size: 17px;
  display: flex; align-items: center; justify-content: center;
}
.pas-head-txt { display: flex; flex-direction: column; line-height: 1.3; }
.pas-head-txt span { font-size: 14px; font-weight: 800; color: var(--text); }
.pas-head-txt small { font-size: 11px; color: var(--text2); }
.pas-close {
  background: none; border: none; color: var(--text2); font-size: 20px;
  cursor: pointer; line-height: 1; padding: 4px; border-radius: 6px;
}
.pas-close:hover { color: var(--red); }

.pas-body {
  padding: 16px 18px; display: flex; flex-direction: column; gap: 10px;
  overflow-y: auto;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}

.pas-lbl {
  font-size: 11px; font-weight: 800; text-transform: uppercase;
  letter-spacing: .4px; color: var(--text2);
}

.pas-search {
  display: flex; align-items: center; gap: 8px;
  padding: 0 11px; height: 38px;
  background: var(--surface2); border: 1px solid var(--border); border-radius: 8px;
}
.pas-search i { color: var(--text3); font-size: 15px; }
.pas-search input {
  flex: 1; min-width: 0; background: none; border: none; outline: none;
  color: var(--text); font-family: inherit; font-size: 13px;
}
.pas-search input::placeholder { color: var(--text3); }

/* La liste occupe seule l'écran à l'étape 1 : elle peut respirer, ce qui
   réduit le défilement quand l'établissement compte beaucoup de serveurs. */
.pas-liste {
  display: flex; flex-direction: column; gap: 4px;
  max-height: 46vh; overflow-y: auto;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}
.pas-item {
  display: flex; align-items: center; gap: 10px;
  padding: 9px 11px; width: 100%; text-align: left; cursor: pointer;
  background: var(--surface2); border: 1px solid var(--border);
  border-radius: 8px; color: var(--text); font-family: inherit;
}
.pas-item:hover { border-color: var(--accent); }
.pas-item.active {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 10%, var(--surface2));
}
.pas-item-ini {
  width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: color-mix(in srgb, var(--accent) 20%, transparent);
  color: var(--accent); font-size: 11px; font-weight: 800;
}
.pas-item-nom { flex: 1; min-width: 0; font-size: 13px; font-weight: 700; }

/* Repère de file, discret : il informe sans donner l'impression d'un blocage - un serveur peut légitimement redemander un QR. */
.pas-item-fait {
  display: inline-flex; align-items: center; gap: 3px; flex-shrink: 0;
  padding: 2px 7px; border-radius: 20px;
  background: color-mix(in srgb, var(--green) 14%, transparent);
  color: var(--green); font-size: 10px; font-weight: 800;
}
.pas-item-fait i { font-size: 12px; }

/* Retour à la liste : discret en haut, l'action franche est en pied de modale. */
.pas-retour {
  display: inline-flex; align-items: center; gap: 6px; align-self: flex-start;
  background: none; border: none; cursor: pointer; padding: 2px 0;
  color: var(--text2); font-family: inherit; font-size: 12px; font-weight: 700;
}
.pas-retour:hover { color: var(--accent); }

.pas-vide {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: 26px 12px; text-align: center; gap: 4px; color: var(--text3);
}
.pas-vide i { font-size: 30px; }
.pas-vide p { font-size: 13px; font-weight: 600; color: var(--text2); margin: 0; }
.pas-vide small { font-size: 11px; }

.pas-qr-zone { display: flex; flex-direction: column; align-items: center; gap: 8px; }
.pas-qr-load { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 24px; color: var(--text2); }
.pas-spin { font-size: 24px; animation: pas-rot 1s linear infinite; }
@keyframes pas-rot { to { transform: rotate(360deg); } }

/* Le QR reste sur fond blanc pur quel que soit le thème de la caisse :
   c'est une exigence de lecture optique, pas un choix esthétique. */
.pas-qr-wrap { background: #fff; padding: 10px; border-radius: 10px; }
/* Plus grand qu'avant : le QR est désormais seul à l'écran, et l'URL atteint
   ~490 caractères. Chaque pixel gagné compte pour un téléphone d'entrée de
   gamme dans une salle peu éclairée. */
.pas-qr { display: block; width: 100%; max-width: 300px; height: auto; }

.pas-consigne {
  margin: 0; font-size: 11px; color: var(--text2); text-align: center; line-height: 1.7;
}
.pas-consigne strong { color: var(--accent); }
.pas-pour { margin: 0; font-size: 13px; color: var(--text2); }
.pas-pour strong { color: var(--text); }

.pas-lien { width: 100%; font-size: 11px; color: var(--text2); }
.pas-lien summary { cursor: pointer; padding: 4px 0; }
.pas-lien-row { display: flex; align-items: center; gap: 6px; }
.pas-lien-row code {
  flex: 1; min-width: 0; overflow-wrap: anywhere;
  background: var(--surface2); border: 1px solid var(--border);
  border-radius: 6px; padding: 6px 8px; font-size: 10px;
}
.pas-lien-row button {
  background: var(--surface2); border: 1px solid var(--border); border-radius: 6px;
  color: var(--text2); cursor: pointer; padding: 6px 8px; flex-shrink: 0;
}

.pas-err {
  display: flex; align-items: flex-start; gap: 9px; padding: 11px;
  background: color-mix(in srgb, var(--red) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--red) 35%, transparent);
  border-radius: 8px; font-size: 12px; color: var(--red); line-height: 1.5;
}
.pas-err i { font-size: 16px; flex-shrink: 0; }

.pas-foot {
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  padding: 11px 16px; border-top: 1px solid var(--border); flex-shrink: 0;
  background: color-mix(in srgb, var(--surface2) 50%, var(--surface));
}
.pas-foot-info {
  display: flex; align-items: center; gap: 5px;
  font-size: 10px; color: var(--text3); line-height: 1.4;
}
.pas-btn-pri {
  padding: 8px 18px; border-radius: 8px; border: none; flex-shrink: 0;
  background: var(--accent); color: #fff;
  font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit;
}
</style>
